import { ExtParamTypeEnum } from '@valhalla/data/entities';

/**структура получения данных с сервера для таблицы */
export interface IEpTableDataDto<T> {
	data: {
		group: Array<any>;
		data: Array<T>;
		total: number;
		aggregates: any;
	};
	totals: {
		totals: IEpTableDataTotal[];
	};
}

/**значение агрегата по колонке */
export interface IEpTableDataTotal {
	/**id колонки */
	id: number;
	/**имя колонки */
	name: string;
	/**значение агрегата */
	value: number;
}

export interface IEpTableSettingsDto {
	tableSettings?: {
		autosaveEnabled: boolean;
		scrollingHeight?: number;
		id?: number;
		multiselectColumnId?: number;
		rowsPerPage?: number;
		/**Кол-во итераций загрузки одного файла */
		numberOfIterationsForDownloadOneFile?: number;
		/**Кол-во параллельных загрузок */
		numberOfParallelDownloads?: number;
		/**Время ожидания загрузки одного файла */
		timeToWaitForDownloadOneFile?: number;
		/**Время ожидания для повторной загрузки файла */
		timeToWaitForReloadFile?: number;
		/**Загружать файлы в момент вкладывания */
		uploadWhenFileAttach?: boolean;
		/**Ключ выделенного веб-сервера */
		webServerKey?: string;
		useRowIdAsKeyColumn?: boolean;
	};
	tableColumnsSettings?: ITableEpColumnDescription[];
	tableMultiselectColumnsSettings?: ITableEpColumnDescription[];
	readonly: boolean;
	exportEnabled?: boolean;
	importEnabled?: boolean;
}

export interface IGetTableSettingsCriteria {
	epId: number;
	subcatId: number;
	taskId: number;
}

export interface IGetTableDataCriteria {
	epId: number;
	taskId: number;
	meta?: IGetTableDataPayload;
}

export interface IGetTableDataPayload {
	take: number;
	skip: number;
	sort: any[];
	group: any[];
	filter: any;
}

/**описание колонок ДП Таблица*/
export interface ITableEpColumnDescription {
	/**Идентификатор атрибута */
	id: number;

	/**Название столбца, которое будет отображаться в таблице */
	name: string;

	/**значение по умолчанию */
	defaultValue?: string;

	selectUsersDefaultValue?: Array<any>;

	/**Порядок расположения атрибутов (столбцов) в таблице, слева направо */
	orderId?: number;

	/**Тип данных атрибута.
	 * Доступные типы данных: текст, выпадающий список, текст с маской, деньги,
	 * дата, телефон, LookUpField, флажок, число, файл */
	columnType: ExtParamTypeEnum;

	dataSource?: any;
	dataValueField?: string;
	dataTextField?: string;
	setOfElementsAsDataSource?: boolean;

	/**Задается маска для типа данных текст с маской. При описании маски используются следующие спецсимволы:
	 * # - цифра или пробел,
	 * L - обязательно большая буква,
	 * l - обязательно маленькая буква,
	 * a - любой символ,
	 * <n..m> - обязательно числовое значение от n до m,
	 * <Символ1|Символ2|Символ3> - один из указанных символов,
	 * \x - вставить в маску любой символ (например, "\а" вставит в маску символ "а"). */
	mask?: string;

	/**Формировать итоговое значение.
	 * Флажок доступен для типов "Число" или "Деньги" */
	enableTotal?: boolean;

	/**режим отображения колонки */
	mode?: any;

	/**Ширина колонки в пикселях. Если не задано (значение равно 0), то рассчитывается автоматически */
	columnWidth?: number;

	align?: TableEpColumnTextAlign;

	lookupParamSettingId?: any;
	smartExpressionId?: any;

	/**идентификатор другого ДП (для лукапа или выпадающего списка) */
	referencedExtParamId?: any;
	referencedExtParamLookupSettings?: Partial<{
		gridVirtualPageSize: number;
		groupsCollapsed: boolean;
		hierarchyLookupDisableFolderSelection: boolean;
		isDropdownLookup: boolean;
		isHierarchyLookup: boolean;
		isLayoutPlanLookup: boolean;
		smartFilterId: number;
		subcatId: number;
		summaryCategoryId: number;
		viewPageSize: number;
	}>;
	referencedExtParamNumberSettings?: any;
	referencedExtParamSelectUserSettings?: any;

	taskIdContextField?: any;

	/**флаг указывающий прикрепить колонку слева */
	locked?: any;

	virtualColumnReferencedLookupColumnId?: number;

	virtualColumnReferencedExtParamId?: number;

	isVirtual?: boolean;
	maxHeight?: number;
	showImagePreview?: boolean;
	imagePreviewWidth?: number;
	imagePreviewHeight?: number;
	template?: string;
	filter?: string;

	winAppLinks: boolean;

	buttons: Array<any>;
}

/**Определяет способ выравнивания текста в столбце */
export enum TableEpColumnTextAlign {
	/**Способ "по умолчанию" подразумевает выравнивание по левому краю для текстовых полей и по правому краю для чисел. */
	default = 0,

	/**по левому краю */
	left = 1,

	/**по правому краю */
	right = 3,

	/**по центру */
	center = 2,

	/**по ширине */
	onWidth = 4,
}
